<template>
  <div class="row">
      <!-- Top Bar -->
    <div class="top-bar user-actions">
      <div class="top-bar-left"><p>User actions</p></div>
      <burger/>
      <div class="top-bar-right">
        <div class="row al-attendance-filters">
          <div class="top-bar-filter" style="border-left: 0;">
            <div class="container-fluid">
              <search-filter @search="setFilter('query', $event)" />
            </div>
          </div>

          <div class="top-bar-filter al-filter-user">
            <user-search-filter :initial="filters.user_id" @chosen="setFilter('user_id', $event.id)"/>
          </div>

          <div class="top-bar-filter top-bar-filter-calendar">
            <date-filter @selectDay="updateDateFilter($event)"/>
          </div>

          <div class="top-bar-filter top-bar-filter-time">
            <time-filter @selectTime="setTime($event)"/>
          </div>
        </div>
      </div>
    </div>

    <!-- Main Content -->
    <div class="container-main">
      <div class="container-fluid right-container" data-simplebar id="items-container">
        <v-infinite-scroll :loading="$store.state.loading" @bottom="loadMore" :offset='20' style="max-height: 90vh; overflow-y: scroll;">
          <table class="table items-table">
            <tbody>
              <!-- ITEM -->
              <tr class="item" v-for="(item, index) in items" :key="index">
                <td class="avatar">
                  <user-photo :user="item.user" />
                </td>
                <td>
                  <p>Name</p>
                  <p>{{ item.user.first_name }} {{ item.user.last_name }}</p>
                </td>
                <td class="col-id">
                  <p>ID</p>
                  <p>{{ item.id }}</p>
                </td>
                <td>
                  <p>Time</p>
                  <p>{{ moment(item.time).format('MMM DD / h:mm a') }}</p>
                </td>
                <td>
                  <p>Action</p>
                  <p>{{ item.text }}</p>
                </td>
              </tr>
            </tbody>
          </table>
        </v-infinite-scroll>
      </div>
    </div>
  </div>
</template>

<script>
  import UserSearchFilter from '@/components/filters/UserSearch';
  import SearchFilter from '@/components/filters/Search';
  import DateFilter from '@/components/filters/Date';
  import TimeFilter from '@/components/filters/Time';
  import UserPhoto from '@/components/users/Photo';
  import Burger from '@/components/Burger';

  export default {
    name: 'AccessLogs',
    components: {
      UserSearchFilter,
      SearchFilter,
      DateFilter,
      TimeFilter,
      UserPhoto,
      Burger
    },
    data() {
      return {
        load: true,
        items: [],
        filters: {
          'query': '',
          'user_id': null,
          'date': null,
          'start': 0,
          'limit': 20,
          'time_start': { HH: '', mm: '' },
          'time_end': { HH: '', mm: '' },
        },
      };
    },
    mounted() {
      if (this.$router.currentRoute.query.user_id) {
        this.filters.user_id = this.$router.currentRoute.query.user_id;
      }

      this.getItems();
    },
    methods: {
      getFilters() {
        let data = window._.omit(this.filters, ['time_start', 'time_end', 'date']), filters = [];

        window._.forIn(data, function (value, index) {
          if (value != null) {
            filters.push(`${index}=${value}`);
          }
        });

        if (this.filters.date || this.filters.time_start.HH) {
          filters.push(`time_start=${this.getDate()} ${this.getTime(this.filters.time_start)}`);
          filters.push(`time_end=${this.getDate()} ${this.getTime(this.filters.time_end, '23:59:59')}`);
        }

        return filters.join('&');
      },
      getItems(ignoreFilters = false) {
        this.load = true;
        this.resetPagination();

        this.axios.get(`/actions` + `${!ignoreFilters ? `?${this.getFilters()}` : ''}`)
          .then(response => {
            if (!response.data.user_actions.length) {
              this.load = false;
            }

            this.items = response.data.user_actions;
          });
      },
      loadMore() {
        if (!this.load) {
          return;
        }

        this.filters.start += (!this.filters.start ? 20 : 10);
        this.filters.limit = 10;

        this.axios.get(`/actions?${this.getFilters()}`)
          .then(response => {
            if (!response.data.user_actions.length) {
              this.load = false;
            }

            for (let i in response.data.user_actions) {
              this.items.push(response.data.user_actions[i]);
            }
          });
      },
    },
  };
</script>
